<template>
  <div class="products-list-wrap content-table">
    <div v-if="loading" class="products-loading">
      <div class="spinner-border" role="status"></div>
      <p class="mb-0">در حال بارگذاری...</p>
    </div>

    <div v-else-if="!safeItems.length" class="products-empty">
      <i class="bi bi-file-earmark-text"></i>
      <p class="mb-0">{{ restoreState === true ? 'سطل زباله خالی است.' : 'موردی برای نمایش وجود ندارد.' }}</p>
      <router-link v-if="restoreState !== true" class="products-empty-btn" :to="{ name: 'CreateContent' }">
        ساخت محتوای جدید
      </router-link>
    </div>

    <div v-else>
      <!-- mobile cards -->
      <div class="d-lg-none">
        <article v-for="item in safeItems" :key="'card-' + item.id" class="product-card">
          <div class="product-card-top">
            <span class="product-id-chip">#{{ item.id }}</span>
            <status-changer item-type="content" :item="item"/>
          </div>
          <div class="product-card-identity">
            <div class="product-card-thumb">
              <label class="content-thumb-upload" :class="{ 'is-uploading': uploadingId === item.id, 'is-readonly': restoreState === true }"
                     v-b-tooltip.hover :title="restoreState === true ? '' : 'تغییر تصویر'">
                <input v-if="restoreState !== true" type="file" accept="image/*" class="d-none"
                       :disabled="uploadingId === item.id" @change="uploadThumbnail(item, $event)">
                <img v-if="item.thumbnail" :src="item.thumbnail" class="content-thumb" alt="">
                <span v-else class="content-thumb content-thumb--empty"><b-icon icon="image"/></span>
                <span v-if="restoreState !== true" class="content-thumb-upload__overlay">
                  <b-spinner v-if="uploadingId === item.id" small/>
                  <b-icon v-else icon="camera"/>
                </span>
              </label>
            </div>
            <div class="product-card-title">
              <m-a class="product-card-name" target="_blank"
                   :href="{name:setRouteLinkForSiteRoute(),params:{slug:item.slug}}">
                {{ item.title }}
              </m-a>
              <div class="product-card-tags">
                <span class="product-badge is-brand" v-if="authorName(item)">
                  <b-icon icon="person"/> {{ authorName(item) }}
                </span>
                <span class="product-badge content-cat-pill" v-for="cat in itemCategories(item)" :key="'mc-' + item.id + '-' + cat.id">
                  {{ cat.name }}
                </span>
              </div>
            </div>
          </div>
          <div class="product-card-meta">
            <div class="product-meta-box product-meta-actions">
              <span>عملیات</span>
              <div class="product-actions">
                <template v-if="restoreState == true">
                  <span class="product-action-btn is-danger" v-b-tooltip.hover title="حذف دائمی" @click="forceDeleteContent(item)">
                    <b-icon icon="trash"/>
                  </span>
                  <span class="product-action-btn" v-b-tooltip.hover title="بازگردانی" @click="restore(item)">
                    <b-icon icon="arrow-clockwise"/>
                  </span>
                </template>
                <template v-else>
                  <router-link target="_blank" class="product-action-btn" v-b-tooltip.hover title="ویرایش"
                               :to="{ name: 'UpdateContent', params: { slug: item.slug } }">
                    <b-icon icon="pencil"/>
                  </router-link>
                  <span class="product-action-btn is-danger" v-b-tooltip.hover title="حذف" @click="deleteContent(item)">
                    <b-icon icon="trash"/>
                  </span>
                  <duplicate-item class="product-action-btn" :item="item" :item-type="duplicateType"/>
                </template>
              </div>
            </div>
          </div>
        </article>
      </div>

      <!-- desktop table -->
      <div class="table-responsive d-none d-lg-block">
        <table class="products-table">
          <thead>
          <tr>
            <th>عکس</th>
            <th>عنوان</th>
            <th>وضعیت</th>
            <th>نویسنده</th>
            <th>دسته‌بندی</th>
            <th>عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in safeItems" :key="'row-' + item.id">
            <td class="product-identity-cell">
              <div class="product-table-identity">
                <label class="content-thumb-upload product-table-thumb" :class="{ 'is-uploading': uploadingId === item.id, 'is-readonly': restoreState === true }"
                       v-b-tooltip.hover :title="restoreState === true ? '' : 'تغییر تصویر'">
                  <input v-if="restoreState !== true" type="file" accept="image/*" class="d-none"
                         :disabled="uploadingId === item.id" @change="uploadThumbnail(item, $event)">
                  <img v-if="item.thumbnail" :src="item.thumbnail" class="content-thumb" alt="">
                  <span v-else class="content-thumb content-thumb--empty"><b-icon icon="image"/></span>
                  <span v-if="restoreState !== true" class="content-thumb-upload__overlay">
                    <b-spinner v-if="uploadingId === item.id" small/>
                    <b-icon v-else icon="camera"/>
                  </span>
                </label>
                <span class="product-id-chip">{{ item.id }}</span>
              </div>
            </td>
            <td class="product-name-cell">
              <m-a class="product-name-link" target="_blank"
                   :href="{name:setRouteLinkForSiteRoute(),params:{slug:item.slug}}">
                {{ item.title }}
              </m-a>
            </td>
            <td>
              <status-changer item-type="content" :item="item"/>
            </td>
            <td>
              <span v-if="authorName(item)" class="product-badge is-brand">{{ authorName(item) }}</span>
              <span v-else class="product-muted">—</span>
            </td>
            <td>
              <div class="content-cat-pills" v-if="itemCategories(item).length">
                <span class="product-badge content-cat-pill" v-for="cat in itemCategories(item)" :key="'c-' + item.id + '-' + cat.id">
                  {{ cat.name }}
                </span>
              </div>
              <span v-else class="product-muted">—</span>
            </td>
            <td>
              <div class="product-actions">
                <template v-if="restoreState == true">
                  <span class="product-action-btn is-danger" v-b-tooltip.hover title="حذف دائمی" @click="forceDeleteContent(item)">
                    <b-icon icon="trash"/>
                  </span>
                  <span class="product-action-btn" v-b-tooltip.hover title="بازگردانی" @click="restore(item)">
                    <b-icon icon="arrow-clockwise"/>
                  </span>
                </template>
                <template v-else>
                  <router-link target="_blank" class="product-action-btn" v-b-tooltip.hover title="ویرایش"
                               :to="{ name: 'UpdateContent', params: { slug: item.slug } }">
                    <b-icon icon="pencil"/>
                  </router-link>
                  <span class="product-action-btn is-danger" v-b-tooltip.hover title="حذف" @click="deleteContent(item)">
                    <b-icon icon="trash"/>
                  </span>
                  <duplicate-item class="product-action-btn" :item="item" :item-type="duplicateType"/>
                </template>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import StatusChanger from "../../genralComponents/StatusChanger";
import DuplicateItem from "../../genralComponents/DuplicateItem";
import {getAxiosInstance} from "@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance.js";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import "../product/products-ui.css";

export default {
  name: "tabelItems",
  components: {StatusChanger, DuplicateItem,},
  props: {
    items: {
      default: () => []
    },
    restoreState: {},
    loading: {
      type: Boolean,
      default: false
    },
    contentType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      uploadingId: null,
    }
  },
  computed: {
    safeItems() {
      return Array.isArray(this.items) ? this.items : []
    },
    duplicateType() {
      if (this.contentType) return this.contentType
      return this.$route.name === 'PagesDashboard' ? 'page' : 'post'
    }
  },
  methods: {
    formatNumber,
    async uploadThumbnail(item, event) {
      const input = event.target
      const file = input.files && input.files[0]
      if (!file || this.uploadingId !== null) return
      const formData = new FormData()
      formData.append('content_id', item.id)
      formData.append('thumbnail', file)
      this.uploadingId = item.id
      try {
        const res = await getAxiosInstance().post('content/update/thumbnail', formData)
        const thumbnail = res && res.data && res.data.data && res.data.data.thumbnail
        this.$set(item, 'thumbnail', thumbnail ? `${thumbnail}${thumbnail.indexOf('?') > -1 ? '&' : '?'}t=${Date.now()}` : URL.createObjectURL(file))
        toast('با موفقیت انجام شد', 'با موفقیت انجام شد', 'success', 'top-left')
      } catch (e) {
        console.error(e)
        toast('خطا', 'بارگذاری تصویر انجام نشد', 'danger', 'top-left')
      } finally {
        this.uploadingId = null
        input.value = ''
      }
    },
    itemCategories(item) {
      const list = item && (item.category || item.categories)
      return Array.isArray(list) ? list.filter(cat => cat && cat.name) : []
    },
    authorName(item) {
      const author = item && item.author
      if (!author) return ''
      return [author.name, author.last_name].filter(Boolean).join(' ')
    },
    deleteContent(item) {
      if (confirm('آیا از حذف اطمینان دارید؟')) {
        this.$store.dispatch("Content/deleteContent", item);
      }
    },
    // the store removes the item from the trash list locally (no reload)
    restore(item) {
      if (confirm(' بازگردانی  شود؟')) {
        Promise.resolve(this.$store.dispatch("Content/restoreContent", item.id))
            .then(() => toast('عملیات با موفقیت انجام شد', `«${item.title || ''}» بازگردانی شد.`, 'success'))
            .catch(() => toast('خطا', 'بازگردانی انجام نشد.', 'danger'))
      }
    },
    forceDeleteContent(item) {
      if (confirm('آیا از حذف  دائمی اطمینان دارید؟ این کار قابل بازگشت نیست.')) {
        Promise.resolve(this.$store.dispatch("Content/forceDeleteContent", item))
            .then(() => toast('عملیات با موفقیت انجام شد', `«${item.title || ''}» برای همیشه حذف شد.`, 'success'))
            .catch(() => toast('خطا', 'حذف دائمی انجام نشد.', 'danger'))
      }
    },
    setRouteLinkForSiteRoute() {
      const routeName = this.$route.name;
      if (routeName === 'PostsDashboard') return 'SinglePost'
      if (routeName === 'PagesDashboard') return 'SinglePage'
    }
  },
};
</script>

<style scoped>
.content-thumb {
  display: block;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  object-fit: cover;
  background: #f4f4f5;
}

.content-thumb--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b0b0b8;
  font-size: 20px;
}

.content-thumb-upload {
  position: relative;
  display: inline-block;
  margin: 0;
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
}

.content-thumb-upload.is-readonly {
  cursor: default;
}

.content-thumb-upload__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(30, 30, 30, 0.45);
  color: #fff;
  font-size: 18px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.content-thumb-upload:hover .content-thumb-upload__overlay,
.content-thumb-upload.is-uploading .content-thumb-upload__overlay {
  opacity: 1;
}

.content-cat-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 220px;
}

.content-cat-pill {
  background: rgba(235, 61, 96, 0.08);
  color: #eb3d60;
  white-space: nowrap;
}

.content-table .product-name-link {
  white-space: normal;
}
</style>
